// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViewMore_editIcon__qf02v {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
}
.ViewMore_editIcon__qf02v:hover {
  color: var(--color-primary);
}
.ViewMore_editIcon__qf02v > :not(:last-child) {
  font-size: 3rem;
  margin-right: 1rem;
}

.ViewMore_variationsInModal__XViC8 {
  background-color: var(--color-primary-3);
  padding: 1rem;
  width: 100%;
  margin-bottom: 2rem;
}
.ViewMore_variationsInModal_grid__FhyDy {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Inventory/ViewMore.module.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AADJ;AAGI;EACI,2BAAA;AADR;AAII;EACI,eAAA;EACA,kBAAA;AAFR;;AAOA;EACI,wCAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;AAJJ;AAMI;EACI,aAAA;EACA,qCAAA;EACA,SAAA;AAJR","sourcesContent":["@import '../variables/breakpoints';\n\n.editIcon {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    cursor: pointer;\n\n    &:hover {\n        color: var(--color-primary);\n    }\n    \n    &>:not(:last-child) {\n        font-size: 3rem;\n        margin-right: 1rem;\n\n    }\n}\n\n.variationsInModal{\n    background-color: var(--color-primary-3);\n    padding: 1rem;\n    width: 100%;\n    margin-bottom: 2rem;\n\n    &_grid {\n        display: grid;\n        grid-template-columns: repeat(2, 1fr);\n        gap: 1rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editIcon": `ViewMore_editIcon__qf02v`,
	"variationsInModal": `ViewMore_variationsInModal__XViC8`,
	"variationsInModal_grid": `ViewMore_variationsInModal_grid__FhyDy`
};
export default ___CSS_LOADER_EXPORT___;
